import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus';

import Contact from '../../../models/Contact';
import ContactTable from './../contacts/ContactTable';
import pageWrapper from '../../containers/MainPage';
import Breadcrumbs from '../../common/Breadcrumbs';

class ContactsPage extends React.PureComponent {
  render() {
    const { contacts } = this.props;

    const groupedContacts = _.groupBy(contacts, 'type');

    if (_.size(contacts) === 0) {
      return (
        <div className="columns is-centered">
          <div
            className="column is-half notification is-info has-text-centered"
            style={{ marginTop: '20%' }}
          >
            <h5 className="title is-5">You don&apos;t have any contacts yet. </h5>
            <p>
              <Link to="/contacts/new" className="button is-inverted is-medium">
                Add your first one now.
              </Link>
            </p>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Breadcrumbs segments={[{ label: 'Contacts' }]} />

        <div style={{ textAlign: 'right', margin: '0 0 2rem' }}>
          <Link to="/contacts/new" className="button is-link">
            <FontAwesomeIcon icon={faPlus} className="icon" size="xs" />
            <span>Add Contact</span>
          </Link>
        </div>

        {_.map(groupedContacts, (groupContacts, contactType) => (
          <ContactTable contacts={groupContacts} header={contactType} key={contactType} />
        ))}
      </div>
    );
  }
}

ContactsPage.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.instanceOf(Contact)),
};

ContactsPage.defaultProps = {
  contacts: [],
};

function mapStateToProps(state) {
  const {
    contacts: { items },
  } = state;

  return {
    contacts: items,
  };
}

export default pageWrapper(connect(mapStateToProps, undefined)(ContactsPage), 'My Contacts');



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ContactsPage.jsx